import { Injectable } from '@angular/core';
import Swal, { SweetAlertOptions } from 'sweetalert2';

// import {
//   ConfirmEntityDialogComponent,
//   DeleteEntityDialogComponent,
//   FetchEntityDialogComponent,
//   UpdateStatusDialogComponent,
// } from '../../../../views/partials/content/crud';
// import { ImageModalComponent } from './../../../../shared/image-modal/image-modal.component';

// Angular
// Partials for CRUD
export enum MessageType {
  Create,
  Read,
  Update,
  Delete,
}

@Injectable()
export class LayoutUtilsService {

  constructor() {}

  showToastNotification(options: SweetAlertOptions) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 10000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    if (!Object.keys(options).find((e) => e === 'showCloseButton')) {
      options.showCloseButton = true;
    }

    return Toast.fire(options);
  }

  showActionNotification(options: SweetAlertOptions) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-secondary',
        denyButton: 'btn btn-secondary',
      },
      buttonsStyling: false,
      cancelButtonText: 'Cancelar'
    });

    return swalWithBootstrapButtons.fire(options);
  }

  /**
   * Showing Confirmation (Mat-Dialog) before Entity Removing
   *
   * @param title: stirng
   * @param description: stirng
   * @param waitDesciption: string
   */
  // deleteElement(
  //   title: string = '',
  //   description: string = '',
  //   waitDesciption: string = ''
  // ) {
  //   return this.dialog.open(DeleteEntityDialogComponent, {
  //     data: { title, description, waitDesciption },
  //     width: '440px',
  //   });
  // }

  // // Method returns instance of MatDialog
  // confirmElement(
  //   title: string = '',
  //   description: string = '',
  //   waitDesciption: string = ''
  // ) {
  //   return this.dialog.open(ConfirmEntityDialogComponent, {
  //     data: { title, description, waitDesciption },
  //     width: '440px',
  //   });
  // }

  // openImage(title, imagePath) {
  //   return this.dialog.open(ImageModalComponent, {
  //     data: { title, imagePath },
  //     width: '480px',
  //   });
  // }
}
